import { cn } from "@/lib/utils"
import { FileTypeIcon } from "@/components/ui/file-type-icon"

/** Display-only ref — never carries the s3Key. */
export interface AttachmentChipRef {
  attachmentId: string
  filename: string
  mimeType: string
  size?: number
}

interface AttachmentChipsProps {
  attachments: AttachmentChipRef[]
  className?: string
}

/**
 * Read-only chips for the files attached to a user message. Shared by the
 * Assistant/Tender chat bubble and the AI panel bubble so both surfaces stay
 * identical.
 */
export function AttachmentChips({ attachments, className }: AttachmentChipsProps) {
  if (attachments.length === 0) return null

  return (
    <div className={cn("flex flex-wrap gap-1 mb-1.5", className)}>
      {attachments.map((attachment) => (
        <span
          key={attachment.attachmentId}
          className="inline-flex items-center gap-1 rounded-md bg-background/50 px-2 py-0.5 text-meta"
        >
          {/* glyph, not badge — the badge's three-letter stamp is illegible at 12px */}
          <FileTypeIcon
            variant="glyph"
            mimeType={attachment.mimeType}
            fileName={attachment.filename}
            size={12}
          />
          <span className="max-w-[150px] truncate">{attachment.filename}</span>
        </span>
      ))}
    </div>
  )
}
